export const invoiceTemplate = `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <link href="https://fonts.googleapis.com/css2?family=Lato&display=swap" rel="stylesheet" />
      <title>Document</title>
      <style>
        * {
          margin: 0;
          padding: 0;
        }
        body,
        html {
          font-family: Lato, sans-serif;
          font-size: 1rem;
          width: 595pt;
          height: auto;
          padding-bottom: 2rem;
        }
        table {
          border-collapse: collapse;
          width: 100%;
        }
        th {
          border: 1px solid #bbb;
          padding: 8px;
        }
        td {
          border: 1px solid #bbb;
          padding: 4px;
        }
        .container {
          display: flex;
          flex-direction: column;
          width: 700px;
          margin: auto;
          justify-content: space-evenly;
        }
        .header-style {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 0.5rem;
          margin-bottom: 1rem;
        }
        .purchases-info {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-top: 0.5rem;
          margin-bottom: 1rem;
          width: 100%;
        }
        .subtotal-table {
          display: flex;
          justify-content: flex-end;
          margin-top: 1rem;
          margin-bottom: 2.5rem;
        }
        .footer-note {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          margin-top: 2rem;
        }
        .sign-alignment {
          display: flex;
          justify-content: space-between;
          margin-top: 2rem;
        }
        span {
          font-weight: 700;
        }
        .sign-alignment > div > hr {
          width: 160px;
          margin-top: 4rem;
        }
        .company-title {
          display: flex;
          justify-content: center;
          margin-top: 2rem;
          margin-bottom: 1rem;
        }
        .company-title > p {
          font-size: 1.5rem;
          font-weight: 600;
          color: rgba(179, 102, 31, 0.925);
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="company-title"><p>{{company.name}}</p></div>
        <div class="header-style">
          <div>
            <img src="{{company.image}}" alt="Company Logo" width="100px" height="100px" />
          </div>
          <div style="line-height: 1.5; flex-basis: 250px;">
            <p><span>Company Name: </span>{{company.name}}</p>
            <p><span>Phone Number: </span>{{company.number}}</p>
            <p><span>Email: </span>{{company.email}}</p>
            <p><span>Address: </span>{{company.address}}</p>
          </div>
        </div>
        <hr style="border: 0; height: 1px; background-color: #ccc" />
        <div class="purchases-info">
          <div style="width: 50%; padding-right: 1rem;">
            <h5>Bill To</h5>
            <p>Name: {{client.name}}</p>
            <p>Address: {{client.address}}</p>
            <p>Phone: {{client.mobileNumber}}</p>
            <p>Email: {{client.email}}</p>
          </div>
          <div style="width: 50%; padding-left: 5rem; text-align: right">
            <h5>Quotation Details</h5>
            <p>Quotation No: {{invoiceId}}</p>
            <p>Date: {{invoiceDate}}</p>
            <p>Warehouse: {{warehouse}}</p>
            <p>Processed By: {{salesman}}</p>
          </div>
        </div>
        <div>
          <div style="margin: 1rem 0 0">
            <table style="width: 100%">
              <tr>
                <th>Sl.</th>
                <th>SKU</th>
                <th>Description</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Discount</th>
                <th>Subtotal</th>
              </tr>
              {{#each products}} {{> productTableRow product=.}} {{/each}}
              <tr>
                <td colspan="5" style="border: none"></td>
                <td><span>Subtotal:</span></td>
                <td>TK {{subtotal}}</td>
              </tr>
              <tr>
                <td colspan="5" style="border: none"></td>
                <td><span>Per Item Discount:</span></td>
                <td>TK {{perItemDiscount}}</td>
              </tr>
              <tr>
                <td colspan="5" style="border: none"></td>
                <td><span>Order Discount:</span></td>
                <td>{{orderDiscountEntry}}</td>
              </tr>
              <tr>
                <td colspan="5" style="border: none"></td>
                <td><span>Total Discount:</span></td>
                <td>TK {{totalDiscountAmount}}</td>
              </tr>
              <tr style="font-weight: 800">
                <td colspan="5" style="border: none"></td>
                <td><span>Total:</span></td>
                <td>TK {{totalAmount}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="footer-note">
          <div><p>Note: {{note}}</p></div>
          <div style="display: flex; justify-content: center; margin-top: 2rem">
            <h4>Thanks for being with us.</h4>
          </div>
          <div class="sign-alignment">
            <div>
              <h4>Received By:</h4>
              <hr />
              <p>Signature & Date</p>
            </div>
            <div>
              <h4>Delivered By:</h4>
              <hr />
              <p>Signature & Date</p>
            </div>
          </div>
        </div>
      </div>
    </body>
  </html>
`;

export const posReceiptTemplate = `
  <!DOCTYPE html>
  <html>
  <head>
    <link href="https://fonts.googleapis.com/css2?family=Lato&display=swap" rel="stylesheet" />
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body,
      html {
        font-family: Lato, sans-serif;
        font-size: 1rem;
        width: 100%;
        letter-spacing: 1px;
        line-height: 1.5;
      }

      p {
        font-size: 0.7em;
        color: #666;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        color: #666;
        line-height: 2;
      }

      th {
        color: #444;
      }

      .ls4 {
        letter-spacing: 4px;
      }

      .py1 {
        padding-top: 1mm;
        padding-bottom: 1mm;
      }

      .pt3 {
        padding-top: 3mm;
      }

      .bold {
        font-weight: bold;
      }

      tr {
        font-size: .6em;
      }

      .receipt {
        margin: 0 auto;
        padding: 0 4mm;
        background: #FFF;
      }

      .receipt-header {
        padding: 5mm 0 3mm;
        line-height: 1.2;
      }

      .receipt-header_title {
        letter-spacing: 2px;
      }

      .receipt-sub-section {
        line-height: 2;
        font-weight: 600;
      }

      .receipt-header_date {
        padding-top: 3mm;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .pos-invoice_table-title {
        font-size: .5em;
        text-align: left;
      }

      .price {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .note {
        padding-bottom: 5mm;
      }
    </style>
  </head>
  <body>
    <div class="receipt">
      <div class="receipt-header">
        <center>
          <h1 class='receipt-header_title'>{{company.name}}</h1>
          <p>Address: {{company.address}}</p>
          <p>Tel: {{company.number}}</p>
          <p class='py1'>BIN: {{company.bin}}</p>
          <p>{{company.tax}}</p>
          <p class='py1'>Invoice: {{invoiceId}}</p>
        </center>

        <div class='receipt-header_date'>
          <p>Date: {{date}}</p>
          <p>Time: {{time}}</p>
        </div>

        <center>
          <p class='pt3'>Processed by: {{processedBy}}</p>
        </center>
      </div>

      <p class='ls4'>************************************</p>
      <div class='receipt-sub-section'>
        <center>
          <p class='ls3'>CASH RECEIPT</p>
        </center>
      </div>
      <p class='ls4'>************************************</p>

      <table>
        <tr class='pos-invoice_table-title'>
          <th style="width:15%">SKU</th>
          <th style="width:25%">Name</th>
          <th style="width:10%">Qty</th>
          <th style="width:20%">Unit Price</th>
          <th style="width:15%">Discount</th>
          <th style="width:15%">Net Total</th>
        </tr>
        {{#each products}} {{> productTableRow product=.}} {{/each}}
      </table>

      <p class='ls4'>************************************</p>
        {{#if vat}}
        <div class='price'>
          <p>Actual Price</p>
          <p>TK {{vat.actualPrice}}</p>
        </div>
        <div class='price'>
          <p>VAT {{vat.percent}}%</p>
          <p>TK {{vat.amount}}</p>
        </div>
        {{/if}}
        <div class='price'>
          <p>Net Total</p>
          <p>TK {{netTotal}}</p>
        </div>
        <div class='price'>
          <p>Per Item Discount</p>
          <p>TK {{perItemDiscount}}</p>
        </div>
        <div class='price'>
          <p>Order Discount</p>
          <p>{{orderDiscountEntry}}</p>
        </div>
        <div class='price'>
          <p>Total Discount</p>
          <p>TK {{totalDiscount}}</p>
        </div>
        {{#if shipping}}
        <div class='price'>
          <p>Shipping</p>
          <p>TK {{shipping}}</p>
        </div>
        {{/if}}
        <div class='price'>
          <h5>Total</h5>
          <h5>TK {{total}}</h5>
        </div>
        <div class='price'>
          <p>Cash</p>
          <p>TK {{cash}}</p>
        </div>
        <div class='price'>
          <p>Change</p>
          <p>TK {{change}}</p>
        </div>
      <p class='ls4'>************************************</p>

      <div class='note'>
        <center>
          <p>Thank You!</p>
          <p>Powered by Elobooks</p>
        </center>
      </div>
    </div>
  </body>
  </html>
`;
